import ConfirmaCodigo from "@/views/novo-usuario/ConfirmaCodigo.vue";
import Cadastro from "@/views/publico/Cadastro.vue";
import CadastroToken from "@/views/publico/CadastroToken.vue";

const novoUsuarioRotas = [
  {
    path: "/confirma-email",
    name: "confirma-email",
    component: ConfirmaCodigo,
  },
  {
    path: "/editar-cadastro",
    name: "editar-cadastro",
    component: Cadastro,
  },
  {
    path: "/concluir-cadastro-token",
    name: "concluir-cadastro-token",
    component: CadastroToken,
  },
];

export { novoUsuarioRotas };
